<template>
  <router-link :to="{ name: 'home' }" class="d-flex align-center">
   <!--  <img
      src="@/assets/logo.png"
      alt="logo"
      :class="noLogo ? 'd-none' : 'd-inline'"
    /> --><span :class="noText ? 'd-none' : 'ml-1 d-inline'">Edwork</span>
  </router-link>
</template>

<script>
export default {
  props: {
    noLogo: {
      type: Boolean,
    },
    noText: {
      type: Boolean,
    },
  },
};
</script>

<style scoped>
img[src*="logo"] {
  max-width: 25px;
}
a,
a:hover,
a:visited,
a:link,
a:active {
  color: var(--white);
  font-weight: 500;
  line-height: 36px;
  text-decoration: none;
}
@media screen and (min-width: 600px) {
  a,
  a:hover,
  a:visited,
  a:link,
  a:active {
    color: var(--black);
  }
}
</style>